const initializedSections = new WeakSet();

const getSections = (scope) => {
  if (scope.matches?.('.case-studies-head-sec')) {
    return [scope];
  }

  return Array.from(scope.querySelectorAll('.case-studies-head-sec'));
};

const revealSection = (section) => {
  section.classList.add('is-visible');
};

export function initCaseStudiesHead(scope = document) {
  if (!scope?.querySelectorAll) {
    return;
  }

  const sections = getSections(scope);

  sections.forEach((section) => {
    if (initializedSections.has(section)) {
      return;
    }

    initializedSections.add(section);

    const hasBg = !!section.querySelector('.case-studies-head-sec__bg');

    if (!hasBg || typeof IntersectionObserver === 'undefined') {
      revealSection(section);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          revealSection(section);
          observer.unobserve(section);
        });
      },
      {
        rootMargin: '0px 0px -18% 0px',
        threshold: 0.2,
      }
    );

    observer.observe(section);
  });
}

globalThis.initCaseStudiesHead = initCaseStudiesHead;

if (typeof document !== 'undefined' && !document.querySelector('.bold-loader-new')) {
  initCaseStudiesHead();
}
